<template functional>
  <v-avatar
    :key="props.user.name"
    v-lazy-load-image
    v-fake-avatar="props.user"
    v-tooltip="props.tooltip"
    v-bind="data.attrs"
    :class="[data.class, data.staticClass]"
    v-on="listeners"
  >
    <img
      :src="props.user[props.userImagePath]"
      :alt="props.user.name"
    >
  </v-avatar>
</template>

<script>
import Vue from 'vue';
import { VAvatar } from 'vuetify';
import VTooltip from 'v-tooltip';
import './lazy_load.directive';
import './fake-avatar.directive';
import '@stilingue/st-styles/main.scss';

Vue.component('v-avatar', VAvatar);
Vue.use(VTooltip);

export default {
  name: 'StUserAvatar',
  props: {
    user: {
      type: Object,
      required: true
    },
    userImagePath: {
      type: String,
      default: 'img'
    },
    tooltip: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss">
  @import '~@stilingue/st-styles/v-tooltip.scss';
</style>
